import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  // True while staff/admin are viewing the Non-Member Management section of the
  // admin dashboard, so the global header bar can turn orange (the app's
  // green = members / orange = non-members visual language).
  adminNonMemberView: boolean;
}

const initialState: UIState = {
  adminNonMemberView: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setAdminNonMemberView: (state, action: PayloadAction<boolean>) => {
      state.adminNonMemberView = action.payload;
    },
  },
});

export const { setAdminNonMemberView } = uiSlice.actions;
export default uiSlice.reducer;
